<template>
  <div>
    <div :class="{'search-sticky': scroll, 'active-sticky shadow-lg': isActiveScroll}">
      <b-input-group class="input-group-merge">
        <b-input-group-prepend is-text>
          <feather-icon icon="SearchIcon" />
        </b-input-group-prepend>
        <b-form-input
          v-model="keyword"
          placeholder="Search"
          debounce="500"
        />
      </b-input-group>
    </div>

    <b-row>
      <b-col cols="12">
        <slot name="content" />
        <slot
          v-if="!keyword"
          name="emptyState"
        />
      </b-col>

      <b-col cols="12">
        <hr
          v-if="productsSearch.length"
          class="my-1"
        >
      </b-col>

      <b-col
        v-if="keyword && !isLoadingSearch && !productsSearch.length"
        cols="12"
      >
        <div
          class="text-center my-2"
        >
          {{ searchEmptyResult }}
        </div>
      </b-col>

      <b-col>
        <div
          v-show="isLoadingSearch"
          class="text-center my-1"
        >
          <b-spinner
            variant="primary"
            small
          />
        </div>

        <div
          v-if="!isLoadingSearch && productsSearch.length"
          class="mt-1"
          :class="{ 'scrollable': scroll }"
        >
          <div
            v-for="(item, index) in productsSearch"
            :key="`list-item-${index}`"
            @click.prevent="onPickProduct(item)"
          >
            <ProductItem
              :img="item.images.length ? item.images[0].image_url : ''"
              :title="item.name"
              :subtitle="`by ${item.merchant.name}`"
              :badge="advance ? !item.is_out_of_stock ? '' : 'light-danger|Stok Habis' : ''"
              :price="toCurrency(item.price ? item.price : 0)"
              :opacity="advance ? item.is_out_of_stock ? 0.5 : 1 : 1"
              :hoverable="isHover(item)"
              :shadow="shadowItem"
              :selected="selectedIndicator ? selectedItem.find(el => el.id === item.id) ? true : false : false"
              :padding-item="paddingItem"
            />
          </div>

          <div
            v-if="loadMore"
            class="load-more text-center mt-2 mb-1"
          >
            <b-button
              v-if="productsMetaSearch && productsMetaSearch.page < productsMetaSearch.total_page"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="primary"
              :disabled="isLoadingLoadMore"
              @click="onLoadMore(productsMetaSearch.page)"
            >
              <b-spinner
                v-show="isLoadingLoadMore"
                small
              />
              Lihat lebih banyak
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BRow,
  BCol,
  BSpinner,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ProductItem from '@/layouts/components/custom/ProductItem.vue'

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BButton,

    ProductItem,
  },
  directives: {
    Ripple,
  },
  props: {
    shadowItem: {
      type: Boolean,
      default: false,
    },
    advance: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 5,
    },
    scroll: {
      type: Boolean,
      default: false,
    },
    selectedIndicator: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    loadMore: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: undefined,
    },
    initSelectedItem: {
      type: Array,
      default: () => ([]),
    },
    searchEmptyResult: {
      type: String,
      default: 'Tidak ada produk yang ditemukan',
    },
    paddingItem: {
      type: Boolean,
      default: false,
    },
    initialKeyword: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoadingSearch: false,
      isLoadingLoadMore: false,
      keyword: '',
      selectedItem: this.initSelectedItem,
      windowTop: 0,
    }
  },
  computed: {
    ...mapState('products', ['isLoading', 'productsSearch', 'productsMetaSearch']),
    isActiveScroll() {
      return this.windowTop >= 300
    },
  },
  watch: {
    async keyword(val) {
      await this.$store.commit('products/RESET_PRODUCT_SEARCH')
      await this.$store.commit('products/RESET_PRODUCT_SEARCH_META')
      this.onSearchProduct(val)
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    if (this.initialKeyword) {
      this.keyword = this.initialKeyword
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions('products', ['searchProducts']),
    onPickProduct(data) {
      if (this.selectedIndicator) {
        if (!this.selectedItem.find(el => el.id === data.id)) {
          if (this.multiple) {
            this.selectedItem.push(data)
          } else {
            this.selectedItem = []
            this.selectedItem.push(data)
          }
          this.$emit('on-select', data)
        }
      } else {
        this.$emit('on-select', data)
      }
    },
    async onSearchProduct(keyword, page = 1) {
      if (keyword.length) {
        if (page === 1) {
          this.isLoadingSearch = true
        } else {
          this.isLoadingLoadMore = true
        }

        await this.searchProducts({
          keyword,
          limit: this.limit,
          loadMore: this.loadMore,
          page,
          filter: this.filter ? { ...this.filter } : undefined,
        })
        this.isLoadingSearch = false
        this.isLoadingLoadMore = false
      }
    },
    isHover(item) {
      if (this.advance) {
        return !item.is_out_of_stock
      }

      if (this.selectedIndicator) {
        return !this.selectedItem.find(el => el.id === item.id)
      }

      return true
    },
    async onLoadMore(page) {
      const nextPage = await page + 1
      await this.onSearchProduct(this.keyword, nextPage)
    },
    onUnPickProduct(data) {
      const index = this.selectedItem.findIndex(el => el.id === data.id)
      this.selectedItem.splice(index, 1)
      return index
    },
    onScroll() {
      this.windowTop = window.top.scrollY /* or: e.target.documentElement.scrollTop */
    },
    initSelectedItems(data) {
      this.selectedItem = data
    },
  },
}
</script>

<style lang="scss" scoped>
.scrollable {
}

.search-sticky {
  position: sticky;
  width: 100%;
  top: 90px;
  z-index: 11;
}
</style>
